<template>
  <SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <!-- Titolo -->
        <div class="titolo-card">
          <h1>Elenco Prenotazioni</h1>
        </div>

        <!-- Loader -->
        <div class="loader" v-if="isLoading">
          <h4>CARICAMENTO IN CORSO...</h4>
        </div>

        <!-- Campi per la ricerca -->
        <div class="search-container">
          <div class="search-field">
            <input type="text" v-model="searchEmail" placeholder="Cerca per email..." class="search-bar">
          </div>
          
          <div class="search-field">
            <input type="text" v-model="searchSurname" placeholder="Cerca per cognome..." class="search-bar">
          </div>
          <button @click="searchUsers" class="search-button"><span class="material-icons">search</span>
</button>
          <button @click="refreshSlot" class="search-button"><span class="material-icons">autorenew</span>
          </button>

          <button @click="goToSlot" class="create-user-button">Blocca slot</button>

        </div>


<!-- Accordion delle prenotazioni -->
<div v-for="(slotsGroup, date) in slots" :key="date" class="card-container">
  <div class="card-header" @click="toggleAccordion(date)">
    <h4>
      {{ formattaData(date) }} - 
      <span class="slots-prenotati">{{ slotsGroup.length }} / 40</span>
      
    </h4>
    <span class="material-icons">
      {{ currentAccordion === date ? 'expand_less' : 'expand_more' }}
    </span>
  </div>
  <div v-if="currentAccordion === date">
    <table>
      <thead>
        <tr>
          <th>Orario</th>
          <th>Studio</th>
          <th>Nome</th>
          <th>Cognome</th>
          <th>Email</th>
          <th>Videocall</th>
          <th>Nutrizionista</th>
          <th>Utente</th>
          <th>Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="slot in slotsGroup" :key="slot.id" :class="{'videocall-fatta': slot.videocall === 'Fatta', 'videocall-annullata': slot.videocall === 'Annullata'}">
          <td>{{ slot.orario }}</td>
          <td>{{ slot.userStudio }}</td>
          <td>{{ slot.userName }}</td>
          <td>{{ slot.userSurname }}</td>
          <td>{{ slot.userEmail }}</td>
          <td>
            <select v-model="slot.videocall" @change="updateVideocallStatus(slot.id, slot.videocall)">
  <option value="">Seleziona...</option>
  <option value="Fatta">Fatta</option>
  <option value="Annullata">Annullata</option>
  <option value="Spostata">Spostata</option>
</select>
          </td>
          <td>
            <select v-model="slot.nutrizionista" @change="updateNutrizionista(slot.id, slot.nutrizionista)">
              <option value="">Seleziona...</option>
              <option value="Martina">Martina</option>
              <option value="Francesca">Francesca</option>
            </select>
          </td>
          <td>
            <select v-model="slot.tipoutente" @change="updateTipoUtente(slot.id, slot.tipoutente)">
              <option value="">Seleziona...</option>
              <option value="Nuovo">Nuovo</option>
              <option value="Rinnovo">Rinnovo</option>
            </select>
          </td>
          <td>
            <button class="delete-slot-button" @click="viewUserDetails(slot.userId)">
                    <span class="material-icons">visibility</span>
                  </button>


            <button @click="deleteSlot(slot.id)" class="delete-slot-button" title="Elimina prenotazione">
  <span class="material-icons">delete</span>
</button>



</td>

        </tr>
      </tbody>
    </table>
    <div class="modal" v-if="showModal">
  <div class="modal-content">
    <p>Sei sicuro di voler cancellare lo slot?</p>
    <button @click="confirmDeletion">Sì</button>
    <button @click="showModal = false">No</button>
  </div>
</div>
  </div>
</div>



      </div>
    </div>
  </div>
</template>


<script>
  import { useRouter } from 'vue-router';
import { getFirestore, collection, getDocs, doc, getDoc, updateDoc, query, where, deleteDoc } from 'firebase/firestore';
import { ref, onMounted } from 'vue';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  components: {
    SidebarComponent
  },
  setup() {
    const router = useRouter();
    const users = ref([]);
    const slots = ref([]);
    const searchEmail = ref('');
    const searchSurname = ref('');
    const isLoading = ref(false);
    const db = getFirestore();
    const currentAccordion = ref(null);
    const showModal = ref(false);
const selectedSlotId = ref(null);

const viewUserDetails = (userId) => {
      router.push({ name: 'UserDetails', params: { userId: userId } });
    };
    

    const toggleAccordion = (date) => {
  currentAccordion.value = currentAccordion.value === date ? null : date;
};


const deleteSlot = (slotId) => {
  selectedSlotId.value = slotId;
  showModal.value = true;
};

const confirmDeletion = async () => {
  if (selectedSlotId.value) {
    await deleteDoc(doc(db, "prenotazioni", selectedSlotId.value));
    console.log('Prenotazione eliminata con successo');
    showModal.value = false;
    
    // Aggiorna gli slot dopo la cancellazione
    for (const date in slots.value) {
      slots.value[date] = slots.value[date].filter(slot => slot.id !== selectedSlotId.value);
      // Se dopo la rimozione, una data non ha più slot, potresti decidere di rimuoverla completamente
      if (slots.value[date].length === 0) {
        delete slots.value[date];
      }
    }
    
    selectedSlotId.value = null;
    // Potresti aver bisogno di forzare Vue a riconoscere l'aggiornamento dell'oggetto slots,
    // specialmente se stai modificando direttamente le sue proprietà
    slots.value = {...slots.value};
  }
};






    const refreshSlot = () => {
      window.location.reload(); // Ricarica la pagina
    };

    const goToSlot = () => {
      router.push('/videocall-list-booking');  // Usa l'istanza del router
    };


    function formattaData(dataInput) {
  // Se dataInput non è una stringa, stampa un errore e ritorna un valore di fallback
  if (typeof dataInput !== 'string') {
    console.error('formattaData ha ricevuto un input non valido:', dataInput);
    return 'Data non disponibile';
  }

  let [anno, mese, giorno] = dataInput.split('-');
  if (anno && anno.length === 4) {
    return `${giorno.padStart(2, '0')}-${mese.padStart(2, '0')}-${anno}`;
  } else {
    return dataInput; // Gestisce il caso in cui la data sia già nel formato desiderato
  }
}



const fetchSlots = async () => {
  isLoading.value = true;
  try {
    const querySnapshot = await getDocs(collection(db, 'prenotazioni'));
    let slotsData = []; // Array per raccogliere i dati degli slot

    querySnapshot.forEach(doc => {
      const data = doc.data();
      if (data.userId && data.stato === 'Booked') { // Controlla se lo slot ha un userId e stato 'Booked'
        slotsData.push({ id: doc.id, ...data }); // Aggiungi allo slotsData se ha un userId
      }
    });

    // Dato che ora slotsData contiene solo slot con userId, procediamo a recuperare i dettagli utente
    let userDetails = {};
    await Promise.all(slotsData.map(async (slot) => {
      const userDoc = await getDoc(doc(db, 'users', slot.userId));
      if (userDoc.exists()) {
        userDetails[slot.userId] = userDoc.data(); // Salva i dettagli utente usando userId come chiave
      }
    }));

    // Associa i dettagli utente agli slot, ora che sappiamo che ogni slot ha un userId valido
    slotsData = slotsData.map(slot => {
      const userDetailsForSlot = userDetails[slot.userId] || {};
      return {
        ...slot,
        userName: userDetailsForSlot.name || '',
        userSurname: userDetailsForSlot.surname || '',
        userEmail: userDetailsForSlot.email || '',
        userStudio: userDetailsForSlot.studio || '',
      };
    });

    // Raggruppa gli slot per data
    let groupedSlots = slotsData.reduce((acc, slot) => {
      const slotDate = slot.data; // Assicurati che sia nel formato corretto
      if (!acc[slotDate]) {
        acc[slotDate] = [];
      }
      acc[slotDate].push(slot);
      return acc;
    }, {});

    slots.value = groupedSlots;
  } catch (error) {
    console.error("Errore nel recupero delle prenotazioni e dettagli utente:", error);
  } finally {
    isLoading.value = false;
  }
};






const searchUsers = async () => {
  isLoading.value = true;
  let userIds = new Set();

  // Cerca per email
  if (searchEmail.value) {
    const emailToSearch = searchEmail.value.toLowerCase();
    const searchByEmailQuery = query(collection(db, "users"), where("email", "==", emailToSearch));
    const emailQuerySnapshot = await getDocs(searchByEmailQuery);
    emailQuerySnapshot.forEach(doc => {
      userIds.add(doc.id);
    });
  }

  // Cerca per cognome
  if (searchSurname.value) {
    const surnameToSearch = searchSurname.value;
    const searchBySurnameQuery = query(collection(db, "users"), where("surname", "==", surnameToSearch));
    const surnameQuerySnapshot = await getDocs(searchBySurnameQuery);
    surnameQuerySnapshot.forEach(doc => {
      userIds.add(doc.id);
    });
  }

  let slotsData = []; // Array per raccogliere i dati degli slot inclusi i dettagli utente

  // Se sono stati trovati degli userIds, cerca gli slot corrispondenti
  if (userIds.size > 0) {
    const slotsQuery = query(collection(db, "prenotazioni"), where("userId", "in", [...userIds]));
    const querySnapshot = await getDocs(slotsQuery);

    slotsData = await Promise.all(querySnapshot.docs.map(async (docSnapshot) => {
      const slot = { id: docSnapshot.id, ...docSnapshot.data() };
      // Formatta correttamente la data dello slot
      slot.data = slot.data instanceof Date ? slot.data.toISOString().split('T')[0] :
                  typeof slot.data === 'string' ? slot.data :
                  'Data non disponibile'; // Gestisci casi in cui la data non è disponibile o non è nel formato corretto
      const userDocSnapshot = await getDoc(doc(db, "users", slot.userId));
      if (userDocSnapshot.exists()) {
        const userData = userDocSnapshot.data();
        return {
          ...slot,
          userName: userData.name || '',
          userSurname: userData.surname || '',
          userEmail: userData.email || '',
          userStudio: userData.studio || '',
        };
      } else {
        return slot; // Ritorna lo slot senza dati utente se l'utente non viene trovato
      }
    }));
  }

  // Raggruppa i dati degli slot per data
  const groupedSlots = slotsData.reduce((acc, slot) => {
    const slotDate = slot.data; // Usa la data formattata
    if (!acc[slotDate]) {
      acc[slotDate] = [];
    }
    acc[slotDate].push(slot);
    return acc;
  }, {});

  slots.value = groupedSlots;
  isLoading.value = false;
};






const updateVideocallStatus = async (slotId, newVideocallStatus) => {
  const db = getFirestore();

  try {
    // Crea un riferimento al documento specifico nello slotId fornito
    const slotRef = doc(db, 'prenotazioni', slotId);
    
    // Aggiorna il campo 'videocall' del documento specificato
    await updateDoc(slotRef, {
      videocall: newVideocallStatus,
    });

    console.log(`Stato videocall aggiornato con successo per: ${slotId}`);
  } catch (error) {
    console.error(`Errore nell'aggiornamento dello stato della videocall per: ${slotId}`, error);
  }
};



const updateNutrizionista = async (slotId, newNutrizionista) => {
  const db = getFirestore();

  try {
    // Crea un riferimento al documento specifico nello slotId fornito
    const slotRef = doc(db, 'prenotazioni', slotId);
    
    // Aggiorna il campo 'videocall' del documento specificato
    await updateDoc(slotRef, {
      nutrizionista: newNutrizionista,
        });

    console.log(`Stato videocall aggiornato con successo per: ${slotId}`);
  } catch (error) {
    console.error(`Errore nell'aggiornamento dello stato della videocall per: ${slotId}`, error);
  }
};

  

const updateTipoUtente = async (slotId, TipoUtente) => {
  const db = getFirestore();

  try {
    // Crea un riferimento al documento specifico nello slotId fornito
    const slotRef = doc(db, 'prenotazioni', slotId);
    
    // Aggiorna il campo 'videocall' del documento specificato
    await updateDoc(slotRef, {
      tipoutente: TipoUtente,
        });

    console.log(`Stato videocall aggiornato con successo per: ${slotId}`);
  } catch (error) {
    console.error(`Errore nell'aggiornamento dello stato della videocall per: ${slotId}`, error);
  }
};






    // Opzionale: Metodo per reset/reload degli slot
    const resetView = () => {
      searchEmail.value = '';
      searchSurname.value = '';
      fetchSlots();
    };

    onMounted(fetchSlots);

    return {
      slots,
      searchEmail,
      searchSurname,
      isLoading,
      searchUsers,
      updateVideocallStatus,
      resetView,
      formattaData,
      goToSlot,
      users,
      refreshSlot,
      toggleAccordion,
      currentAccordion,
      updateNutrizionista,
      deleteSlot,
      confirmDeletion,
      showModal,
      updateTipoUtente,
      viewUserDetails
    };
  },


};

</script>



<style scoped>


.slots-prenotati {
  background-color: #007bff; /* Blu */
  color: white;
  padding: 3px 6px;
  border-radius: 5px;
  margin-left: 10px;
}


.delete-slot-button {
  background-color: transparent; /* Nessuno sfondo */
  border: none; /* Nessun bordo */
  cursor: pointer; /* Cambia il cursore in un puntatore */
  display: flex; /* Usa Flexbox per centrare l'icona */
  align-items: center; /* Centra verticalmente */
  justify-content: center; /* Centra orizzontalmente */
  padding: 0; /* Nessun padding */
  color: #860000; /* Colore dell'icona, ad esempio rosso per 'elimina' */
}

/* Opzionale: Cambiare l'aspetto al passaggio del mouse */
.delete-slot-button:hover {
  color: #d00000; /* Colore dell'icona al passaggio del mouse */
}


.videocall-annullata {
  background-color: #4f0000; /* Rosso chiaro per "Annullata" */
}


.videocall-fatta {
  background-color: #003f00; /* Colore di sfondo verde chiaro per indicare che la videocall è stata fatta */
}

.card-header {
  position: relative;
display: flex;
justify-content: space-between;
align-items: center;
padding-top: 0px;
padding-bottom: 0px;
background: linear-gradient(45deg, #434343 0%, #292929 100%);
color: white;
text-align: left;
border-radius: 23px;
margin-bottom: 0px;
margin-top: 0px;
}

input[type="text"] {
  border-radius: 24px;  /* Angoli stondati */
  background-color: #f1f1f116;  /* Sfondo grigio */
  padding: 11px;  /* Spazio interno */
  border: 1px solid #4c4c4c;  /* Bordo */
  color:rgb(211, 211, 211);
  margin: 2px;
}

input[type="email"] {
  border-radius: 24px;  /* Angoli stondati */
  background-color: #f1f1f116;  /* Sfondo grigio */
  padding: 11px;  /* Spazio interno */
  border: 1px solid #4c4c4c;  /* Bordo */
  color:rgb(211, 211, 211);
  margin-top: 14px;
width: 93%;
margin-bottom: 10px;
}

.search-container {
  display: flex; /* Usa Flexbox */
  align-items: center; /* Centra gli elementi verticalmente */
  justify-content: flex-start; /* Allinea gli elementi all'inizio del contenitore */
  gap: 20px; /* Distanza di 20px tra ogni elemento */
}


.material-icons {
  margin-left: 0px;
  margin-right: 0px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background-color: #303030;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  width: 500px;
  max-width: 80%;
  margin-left: 200px;
  color:#ffffff;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  color:#4c4c4c;
}

.create-user-button {
    padding: 10px 15px;
    border-radius: 24px;
    border: none;
    background-color: #4CAF50; /* Colore del bottone */
    color: white; /* Colore del testo */
    font-size: 1rem;
    cursor: pointer;
    margin-left: 20px;
    /* Aggiungi ulteriori stili a tuo piacimento */
  }

  .create-user-button:hover {
    background-color: #45a049; /* Colore al passaggio del mouse */
  }



button[type="submit"] {
  width: 100%;
  background-color: #4CAF50;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button[type="submit"]:hover {
  background-color: #45a049;
}



</style>
